export default function Services() {
  const services = [
    {
      icon: 'ri-checkbox-multiple-line',
      title: 'Corrección Automatizada OMR',
      description: 'Procesamiento rápido y preciso de hojas de respuesta con tecnología de reconocimiento óptico.',
      features: ['Corrección masiva', 'Alta precisión', 'Múltiples formatos'],
      accent: '#0D9488'
    },
    {
      icon: 'ri-file-chart-line',
      title: 'Reportes Estadísticos Avanzados',
      description: 'Generación automática de informes detallados en Excel y PDF con análisis completo.',
      features: ['Reportes en Excel', 'Gráficos estadísticos', 'Análisis detallado'],
      accent: '#F59E0B'
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Diseño de Plantillas Personalizadas',
      description: 'Creamos plantillas OMR adaptadas a las necesidades específicas de tu institución.',
      features: ['Diseño a medida', 'Múltiples opciones', 'Fácil implementación'],
      accent: '#0D9488'
    }
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-gradient-to-b from-white to-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-[#F59E0B]/10 px-4 md:px-5 py-2 rounded-full mb-4">
            <i className="ri-service-line text-[#F59E0B] text-sm md:text-base"></i>
            <span className="text-[#F59E0B] font-semibold text-xs md:text-sm">Lo Que Hacemos</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E] mb-3 md:mb-4 px-4">
            Nuestros Servicios <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0D9488] to-[#F59E0B]">Especializados</span>
          </h2>
          <p className="text-base md:text-lg text-gray-500 max-w-2xl mx-auto px-4">
            Soluciones completas para la evaluación automatizada de tu institución
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mb-5 md:mb-6 transition-all duration-300" style={{ backgroundColor: `${service.accent}15` }}>
                <i className={`${service.icon} text-2xl md:text-3xl`} style={{ color: service.accent }}></i>
              </div>
              
              <h3 className="text-lg md:text-xl font-bold text-[#1A1A2E] mb-3 md:mb-4 group-hover:text-[#0D9488] transition-colors">
                {service.title}
              </h3>
              
              <p className="text-gray-500 mb-5 md:mb-6 leading-relaxed text-sm">
                {service.description}
              </p>
              
              <ul className="space-y-2.5 md:space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-gray-600">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${service.accent}15` }}>
                      <i className="ri-check-line text-xs" style={{ color: service.accent }}></i>
                    </div>
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}